module.exports = __webpack_public_path__ + "assets/img/loading-cat.gif";